/**
 * Invoice Calculation Functions
 *
 * Pure functions for computing line totals and invoice totals.
 * No database dependencies — safe for use in both service layer and UI.
 */
/**
 * Calculate extended amount for a single line item.
 * Formula: qty * unit_price * (1 - discount / 100), rounded to 2 decimals.
 */
export function calculateLineTotal(quantity, unitPrice, discount) {
    const qty = quantity ?? 0;
    const price = unitPrice ?? 0;
    const disc = discount ?? 0;
    return Math.round(qty * price * (1 - disc / 100) * 100) / 100;
}
/**
 * Sum all line totals into a subtotal, rounded to 2 decimals.
 */
export function calculateSubtotal(lineTotals) {
    const sum = lineTotals.reduce((acc, v) => acc + (v ?? 0), 0);
    return Math.round(sum * 100) / 100;
}
/**
 * Compute invoice total: subtotal + tax.
 * Note: discount_amt (early-pay discount) is NOT subtracted here.
 */
export function calculateTotalAmount(subtotal, taxAmount) {
    return Math.round((subtotal + (taxAmount ?? 0)) * 100) / 100;
}
/**
 * Returns true when the invoice was created manually (no AI extraction).
 */
export function isManualInvoice(extractionMethod) {
    return extractionMethod == null;
}
//# sourceMappingURL=invoiceCalcs.js.map